let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('AgcE+IAAqgIA5AhIAAKkg');
        this.shape.setTransform(-55.4, 32.1);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFFFFF')
            .s()
            .p('ApHEwIRRqAIA9AjIxTJ+g');
        this.shape_1.setTransform(0, -33.8);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#9AA5C0')
            .s()
            .p('AopgSIRTp/IAAKlIxTJ+g');
        this.shape_2.setTransform(2.9, 1.8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol1, new cjs.Rectangle(-58.3, -67.5, 116.7, 135.1), null);

    (lib.Group_3 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('ApsjBITWrKIACROIzWLJg');
        this.shape.setTransform(68.8, 94.7);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('AggIUIgBxOIBCAnIABROg');
        this.shape_1.setTransform(3.4, 128.5);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#E7E7E7')
            .s()
            .p('AqMFRITWrJIBDAnIzWLKg');
        this.shape_2.setTransform(65.3, 37.7);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Group_3, new cjs.Rectangle(0, 0, 130.8, 185.6), null);

    (lib.Group_2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('AjBgiIEsitQAkgVAZAPQAZAOABAqIAAA3QAAAqgZAsQgaAqgkAVIkrCug');
        this.shape.setTransform(61.3, 29.4);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#E7E7E7')
            .s()
            .p('AgDBvIgBAAImBjcIAhgUIGADcIELiaQAkgUAaAPIAhATQgagPgjAVIktCtg');
        this.shape_1.setTransform(39, 13);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#B9C4E3')
            .s()
            .p('AjRAIIAAj+IGiDvIABD/g');
        this.shape_2.setTransform(21, 26.7);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Group_2, new cjs.Rectangle(0, 0, 80.7, 51.5), null);

    (lib.Group_1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AprjBITUrLIAERPIzXLJg');
        this.shape.setTransform(68.7, 94.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#E7E7E7')
            .s()
            .p('AqLFRITUrJIBDAnIzVLKg');
        this.shape_1.setTransform(65.2, 37.7);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#B9C4E3')
            .s()
            .p('AggIUIgBxOIBBAnIACROg');
        this.shape_2.setTransform(3.4, 128.5);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Group_1, new cjs.Rectangle(0, 0, 130.8, 185.6), null);

    (lib.Group_0 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AhUhOICohhIABD+IioBhg');
        this.shape.setTransform(11.8, 19.6);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('AhkAnICnhgIAiATIioBgg');
        this.shape_1.setTransform(10.1, 5.8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Group_0, new cjs.Rectangle(0, 0, 20.3, 37.2), null);

    (lib.Group = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AiGHbIADxPIEKCaIgDROg');
        this.shape.setTransform(13.5, 66.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#E7E7E7')
            .s()
            .p('Aimg4IBEgnIEICYIhCAng');
        this.shape_1.setTransform(17, 9.6);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#B9C4E3')
            .s()
            .p('AgfoTIBCgnIgDRPIhCAmg');
        this.shape_2.setTransform(30.1, 72.5);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Group, new cjs.Rectangle(0, 0, 33.6, 129.6), null);

    // stage content:
    (lib._9 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_2
        this.instance = new lib.Group_2();
        this.instance.parent = this;
        this.instance.setTransform(40.4, 169.7, 1, 1, 0, 0, 0, 40.3, 25.7);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(45));

        // <Group>_1
        this.instance_1 = new lib.Group_1();
        this.instance_1.parent = this;
        this.instance_1.setTransform(97.5, 139.1, 1, 1, 0, 0, 0, 65.3, 92.8);

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(45));

        // Layer_4
        this.instance_2 = new lib.Symbol1();
        this.instance_2.parent = this;
        this.instance_2.setTransform(93.9, 67.5);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .to({y: 98.5}, 14, cjs.Ease.quadInOut)
                .wait(5)
                .to({y: 67.5}, 16, cjs.Ease.quadInOut)
                .wait(10)
        );

        // <Group>_3
        this.instance_3 = new lib.Group_3();
        this.instance_3.parent = this;
        this.instance_3.setTransform(77.6, 127.7, 1, 1, 0, 0, 0, 65.4, 92.8);

        this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(45));

        // Layer_6
        this.instance_4 = new lib.Group_0();
        this.instance_4.parent = this;
        this.instance_4.setTransform(10.1, 154.9, 1, 1, 0, 0, 0, 10.1, 18.6);

        this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(45));

        // Layer_7
        this.instance_5 = new lib.Group();
        this.instance_5.parent = this;
        this.instance_5.setTransform(152.4, 95.8, 1, 1, 0, 0, 0, 16.8, 64.8);

        this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(45));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(85, 116.5, 169.2, 231.9);
    // library properties:
    lib.properties = {
        id: '512761DEE08A46648734587B2AAB2946',
        width: 170,
        height: 233,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['512761DEE08A46648734587B2AAB2946'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('512761DEE08A46648734587B2AAB2946');

export {AdobeAn};
export {composition};
